import exceljs from "exceljs";
import moment from "moment";
import { saveAs } from "file-saver";
import i18n from "@/plugins/vue-i18n";
import Vue from "vue";
import Helper from "@/plugins/Helper/Helper";
export class ExportIncomeExpense {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportIncomeExpense(incomeExpenses, startDate, endDate, summary) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet("sheet1");
    worksheet.columns = [
      {
        header: i18n.t('date'),
        key: 1,
        width: 20,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.number_of_list'),
        key: 2,
        width: 17,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('detail'),
        key: 3,
        width: 30,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('contract.contract_number_only'),
        key: 4,
        width: 17,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('category'),
        key: 5,
        width: 17,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('payment.amount'),
        key: 6,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('tax.tax_vat'),
        key: 7,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('market.total_value'),
        key: 8,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('operator'),
        key: 9,
        width: 17,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
    ]
    let currencyCode = Vue.prototype.$globalCurrencyCode || "THB"
    worksheet.spliceRows(1, 0, {
      1: i18n.t('payment.total_income'),
      2: Helper.round(summary[currencyCode]?.income || 0),
    })
    worksheet.spliceRows(2, 0, {
      1: i18n.t('payment.all_expense'),
      2: Helper.round(summary[currencyCode]?.expense || 0),
    })
    worksheet.spliceRows(3, 0, {
      1: i18n.t('payment.total_all'),
      2: Helper.round((summary[currencyCode]?.income || 0) + (summary[currencyCode]?.expense || 0)),
    })
    worksheet.getCell("B1").font = { color: { argb: "004CAF50" }, bold: true };
    worksheet.getCell("B2").font = { color: { argb: "00F44336" }, bold: true };
    worksheet.getCell("B3").font = { bold: true };
    for (let incomeExpense of incomeExpenses) {
      worksheet.addRow({
        1: incomeExpense.date ? new Date(moment(incomeExpense.date).format("YYYY-MM-DD")) : "",
        2: incomeExpense.documentId,
        3: incomeExpense.detail,
        4: incomeExpense.contractId,
        5: incomeExpense.category,
        6: incomeExpense.totalNonVatValue,
        7: incomeExpense.totalVatValue,
        8: incomeExpense.totalValue,
        9: incomeExpense.createdByText,
      })
    }
    return this.saveFile(workbook, `income-expense-${moment(startDate).format("D-M-YYYY")}-to-${moment(endDate).format("D-M-YYYY")}`);
  }
}